import React, { ReactElement } from "react";
import { UncontrolledCarousel, Container } from "reactstrap";

export const SoundtrackCarousel = (): ReactElement => {
  const items = [
    {
      src: "/images/soundtrack/soundtrack-01.svg",
      altText: "Soundtrack your Party",
      caption: "",
      key: "1",
    },
    {
      src: "/images/soundtrack/soundtrack-02.svg",
      altText: "Soundtrack your BBQ",
      caption: "",
      key: "2",
    },
    {
      src: "/images/soundtrack/soundtrack-03.svg",
      altText: "Soundtrack your B'Day",
      caption: "",
      key: "3",
    },
    {
      src: "/images/soundtrack/soundtrack-04.svg",
      altText: "Soundtrack your Event",
      caption: "",
      key: "4",
    },
    {
      src: "/images/soundtrack/soundtrack-05.svg",
      altText: "Soundtrack your Drinks",
      caption: "",
      key: "5",
    },
    {
      src: "/images/soundtrack/soundtrack-06.svg",
      altText: "Soundtrack your Trip",
      caption: "",
      key: "6",
    },
    {
      src: "/images/soundtrack/soundtrack-07.svg",
      altText: "Soundtrack your Life",
      caption: "",
      key: "7",
    },
  ];

  return (
    <Container className="soundtrack-carousel">
      <UncontrolledCarousel controls={false} indicators={false} items={items} />
    </Container>
  );
};
